import { get, isNil } from 'lodash-es';

import { services } from 'services/base';
import { AboutConfig, MainConfig } from 'types';

export const getConfigs = () => services.appFrame.config.getConfigs();
export const getFeatures = () => services.appFrame.config.getFeatures();

type GetMainConfig = {
  (): MainConfig | undefined | null;
  <Key extends keyof MainConfig>(key: Key): MainConfig[Key] | undefined;
};
export const getMainConfig: GetMainConfig = (key?: string) => {
  const mainConfig = services.appFrame.config.getMainConfig();
  return isNil(key) ? mainConfig : get(mainConfig, key, undefined);
};

export const getModulesConfig = () => services.appFrame.config.getModulesConfig();

export const getConfig = (key, defaultValue) => get(getConfigs(), key, defaultValue);

export const getAboutConfig = (propertyName: keyof Omit<AboutConfig, 'moduleVersions'>) => {
  const aboutConfig = getMainConfig('about');
  return aboutConfig?.[propertyName] ?? undefined;
};
